import React from 'react';
import { useMutation } from '@tanstack/react-query';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { userClient } from '../client/userClient';

export const useSupportContact = () => {
  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback, genericErrorFeedback } = React.useContext(FeedbackContext);

  const sendSupportContact = useMutation({
    mutationKey: [cacheKeys.sendSupportContact],
    mutationFn: userClient.sendSupportContact,
    onSuccess: () => {
      triggerFeedback({
        severity: 'success',
        message: dictionary.users.supportContact.dialog.successMessage,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    sendSupportContact: sendSupportContact.mutateAsync,
  };
};
